import { Pipe, PipeTransform } from '@angular/core';
import { applicationConstants } from '../../../app.constants';

@Pipe({
 name: 'libelleEtatPdp'
})

export class LibelleEtatPdpPipe implements PipeTransform {

	transform(etat: number, args: any[]): string {
	    const isObsolete = args[0];
	    if (isObsolete) {
			return 'Archivé';
		} else if (etat <= applicationConstants.etatPdp.length) {
			return applicationConstants.etatPdp[etat];
		}
 		return '';
   }
   
}